module.exports = __webpack_public_path__ + "assets/img/deividas.056c0611.webp";